module.exports = __webpack_public_path__ + "static/media/voor_wie_is_ifrs.ac9ba265.png";